import Cookies from "universal-cookie";
import { cookiesKeyNames } from "@revbox/common-fe";
import { brandingPPCAuctionsLabels, statusLabels } from "@revbox/localization";
import { getPubAbbr } from "@revbox/helpers-fe";
import { getPathKey } from "../../../../../contexts/CookiesContext";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

const statusMap = {
  PENDING: "badge bg-secondary w-100",
  LIVE: "badge bg-success w-100",
  INACTIVE: "badge bg-danger w-100",
  PAUSED: "badge bg-warning w-100",
  INHERITED: "badge bg-warning w-100",
  "BID ACTIVE": "badge bg-success w-100",
  OUTBID: "badge bg-warning w-100",
};

export function StatusRenderer({ value }) {
  if (!value) {
    return null;
  }
  const cookies = new Cookies();
  const pathKey = getPathKey()
  const languageAbbr = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN';

    const [status, viewsRaw] = value.split("@");
    const translatedStatus = Object.entries(statusLabels[languageAbbr]).find(([key, value]) => value === status);
    const statusKey = translatedStatus[0].toUpperCase();
    const statusValue = translatedStatus[1].toUpperCase();
    let views = Number(viewsRaw);
    let className = statusMap[statusKey];

    // if (status === "LIVE") {
    //   status = "Bid Active".toUpperCase();
    // } 

    // if (views === 0) {
    //   status = "Inherited".toUpperCase();
    //   className = "badge bg-warning w-100";
    // }
    

    return className ? <span className={className}>{statusValue.toUpperCase()}</span> : 
    <span className="badge bg-secondary w-100">{statusLabels[languageAbbr]["Pending"].toUpperCase()}</span>;
}

export function StatusColumnHeaderTooltipRenderer() {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  let tooltip = taxonomy.tooltips.ppc_specific_column_headers.status;

  return tooltip;
}

export function StatusCellTooltipRenderer({ value }) {
  const publisherIdByAbbr = getPubAbbr();
  const taxonomy = TaxonomyModule(publisherIdByAbbr);

  const cookies = new Cookies()
  const pathKey = getPathKey()
  const language = cookies.get(pathKey)?.[cookiesKeyNames.language]?.value || 'EN'

  const message = brandingPPCAuctionsLabels[language].yourStatus;  

  if (!value) {
    return null;
  }
  
  let status = value.split("@")[0]


  if (status === statusLabels[language]["Live"]) {
    return taxonomy.tooltips.ppc_specific_column_inlines.status.live;
  }

  if (status === statusLabels[language]["Inactive"]) {
    return taxonomy.tooltips.ppc_specific_column_inlines.status.inactive;
  }

  if (status === statusLabels[language]["Pending"]) {
    return taxonomy.tooltips.ppc_specific_column_inlines.status.pending;
  }

  if (status === statusLabels[language]["Paused"]) {
    return taxonomy.tooltips.ppc_specific_column_inlines.status.paused;
  }

  return message + " " + status;
}

  